import { useLang } from "@/i18n/LanguageContext";

export function LanguageToggle({ dark = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      className={`inline-flex rounded-md border overflow-hidden ${dark ? "border-white/20" : "border-slate-300"}`}
      data-testid="language-toggle"
    >
      {["tr", "en"].map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-3 py-1.5 text-xs font-semibold tracking-wide transition-colors duration-200 ${
            lang === l
              ? "bg-blue-600 text-white"
              : dark
                ? "text-slate-300 hover:bg-white/10"
                : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
